<template>
  <div class="d-flex flex-column px-1">
    <HeaderBar/>
    <div
      class="d-flex flex-column mb-2 mt-4"
      style="font-size: 15px; font-weight: 500"
    >
        <div class="add-economic-record-title1 mt-2 text-center "> Vacunación por lotes</div>
    </div>
    <div class="d-flex justify-content-center headTitle mb-2">{{fincaName}}</div>
    <validation-observer ref="GanForm" >
        <b-form class="mt-2" @submit.prevent="">
          <!-- date -->
          <b-form-group class=" flex-fill" label="Fecha">
            <validation-provider
            #default="{ errors }" 
            name="Fecha" 
            rules="required">
              <b-form-datepicker v-model="date" class="form-control" 
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              :min="minCfgDate" :max="maxCfgDate"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <!-- vaccineName -->
          <b-form-group label="Nombre de Vacuna" label-for="vaccineName">
            <validation-provider
              #default="{ errors }"
              name="Vacuna"
              rules="required"
            >
              <b-form-input
                id="vaccineName"
                :state="errors.length > 0 ? false : null"
                v-model="vaccineName"
                name="vaccineName"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <!-- averageDose -->
          <b-form-group label="Tipo de Vacuna" label-for="typeIncome">
            <validation-provider
              #default="{ errors }"
              name="Tipo Vacuna"
              rules="required"
            >
            <b-form-select               
            id="typeIncome"
              v-model="vaccine_id"
              :options="typeVaccines"
              :values="typeVaccines.value"
              label="text"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- checkbox -->
          <div class="d-flex column">
          </div>
          <div>
            <b-form-group>
              <!-- table -->
              <small> ⬇ Seleccionar todos</small>
              <vue-good-table :columns="columns" :rows="rows" 
              :search-options="{
                  enabled: false,
              }" 
                          
              :pagination-options="{
                  enabled: true,
                  perPage: pageLength
              }"
              :sort-options="{
                enabled: true,
              }"
              :select-options="{
                  enabled: true,
                  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                  selectionInfoClass: 'custom-class',
                  selectionText: 'rows selected',
                  clearSelectionText: 'clear',
                  disableSelectInfo: true, // disable the select info panel on top
                  selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
              }"

              @on-selected-rows-change="selectedAnimal"
              >
                <template slot="table-row" slot-scope="props">
                  <!-- Column: Name -->
                  <span v-if="props.column.field === 'sex'" class="text-center">
                    <span v-if="props.row.sex===false" class="text-center">M</span>
                    <span v-if="props.row.sex===true" class="text-center">H</span>  
                  </span>

                  <!-- Column: Status -->
                  <span v-else-if="props.column.field === 'status'">
                  <b-badge :variant="statusVariant(props.row.status)">
                      {{ props.row.status }}
                  </b-badge>
                  </span>

                  <!-- Column: Common -->
                  <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>

                <!-- pagination -->
                <template slot="pagination-bottom" slot-scope="props">
                  <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                      <span class="text-nowrap ">
                      Mostrando 1 de
                      </span>
                      <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                      @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                      <span class="text-nowrap"> of {{ props.total }} registros </span>
                  </div>
                  </div>
                </template>
              </vue-good-table>
            </b-form-group>
          </div>
          <div class="mb-5 pb-2">
            <!-- submit buttons -->
            <b-button
              type="submit"  v-on:click="addHealthRecord"
              class="bg-primary dataButton mt-2 mb-5 d-flex align-items-center justify-content-center ml-3"
            >
              <div class="ml-5">Incluir Evento</div>
              <div class="pl-5" style="color: #d7b92c">
                <feather-icon icon="PlusIcon" size="18" />
              </div>
            </b-button>
          </div>
        </b-form>
    </validation-observer>
    <ControlMenu />
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component"
import "vue-select/dist/vue-select.css";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BFormSelect,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckboxGroup,
  BInputGroupAppend,
  BFormDatepicker,
  BInputGroup,
  BFormCheckbox,
} from "bootstrap-vue";
import { required } from '@validations'
import ControlMenu from "@/components/ControlMenu.vue"
import HeaderBar from '@/components/HeaderBar.vue'
import { VueGoodTable } from 'vue-good-table'
import axios from 'axios'



export default {
  components: {
    BButton,
    flatPickr,
    BForm,
    BFormSelect,
    BFormGroup,
    ControlMenu,
    HeaderBar,
    required ,
    BFormCheckboxGroup,
    BFormDatepicker,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    VueGoodTable,
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 119)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate())
    return {
      status: "",
      date:'',
      typeIncome:'',
      maxCfgDate:maxDate,
      minCfgDate:minDate,
      selectedAge: [],
      age: null,
      checked:[],
      typeVaccines:[],
      vaccineName:null,
      type_id:1,
      vaccine_id:null,
      ageOptions: [
        { text: "10" },
        { text: "15" },
        { text: "21" },
        { text: "30" },
        { text: "33" },
      ],
      fincaName:localStorage.getItem('currentFarmName'),
      date:now,
      animal:{
          sex:0
      },
      animals:[],
      pageLength: 25,
      columns: [
          {
              label: 'CODIGO',
              field: 'id',
          },  
          {
              label: 'NOMBRE',
              field: 'name',
          }
      ],
      rows: [],
      vaccinations:[],
    };
  },

  methods: {
    async fetchTypeIncomeOptions(config) {
      fetch(this.$apiUrl+"list/health_data_types?type=1", config)
          .then(response => response.json())
          .then(result => {
              this.typeVaccines = result.health_data_types.map(item => { return { text: item.name, value:item.id}})
          })
    },

    async fetchAnimals(config){
      let farmId= localStorage.getItem('currentFarm');
      //fetch(apiURL+"list/animals?farm_id="+farmId+"&sex=0", config)
      fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&state=1&recperpage=all", config)
      .then(response => response.json())
      .then(result => {
          console.log(result.animals);
          this.rows = result.animals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
          console.log(this.animals);
      })
    },
    async fetchLots(config){
      let farmId= localStorage.getItem('currentFarm');
      //fetch(apiURL+"list/animals?farm_id="+farmId+"&sex=0", config)
      fetch(this.$apiUrl+"list/LotsView?farm_id="+farmId+"&state=1", config)
      .then(response => response.json())
      .then(result => {
          console.log(result);
          this.rows = result.lots.map(item => {return {id:item.id,name:item.name}});
          //console.log(this.lots);
      })
    },
    
    selectedAnimal(params){
        console.log(params.selectedRows);
        this.vaccinations= params.selectedRows.map(item=>{return {lot_id:item.id, product_name:this.vaccineName,vaccine_id:this.vaccine_id,date:this.date,type_id:this.type_id,farm_id:localStorage.getItem('currentFarm')}})
    },
    
    addHealthRecord() {
      this.$refs.GanForm.validate().then(success => {
        if(success){
          console.log(this.vaccinations);
          let self=this;
          const token = localStorage.getItem("accessToken");
          const config = {headers: {"X-Authorization": `Bearer ${token}`}};
          var request= this.vaccinations.map(items =>this.$http.post("add/lots_health_records", items, config));
          axios.all(request)
          .then((result)=>{
            console.log(result)
            this.$swal({
                title: 'Registro de vacucación',
                text: 'Se insertaron los registros de vacuación de manera satisfactoria',
                type: 'success',
                icon:'success',
                showCancelButton: false,
                confirmButtonColor:'#5E8F23',
                showCloseButton: true,
                showLoaderOnConfirm: false  
            }).then(function(){
                history.back();
            });
          });
        }
      })
    }
  },

  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    this.fetchAnimals(config);
    this.fetchLots(config);
    this.fetchTypeIncomeOptions(config);
  }
};
</script>

<style lang="scss">
.titleVaccines {
  
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 29px;
  color: #5e5873;
}

.dataButton {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.4px;
  color: #ffffff;
  flex: none;
  order: 1;
}

.headTitle {
  font-weight: 600;
  font-size: 24px;
  color: #5E8F23;
}

@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>